import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { UserData } from './type';

const initialState: {
	user: UserData | null;
	isLogin: boolean;
	isFetching: boolean;
	isAuthenticatedUser: boolean;
} = {
	user: null,
	isLogin: false,
	isFetching: true,
	isAuthenticatedUser: localStorage.getItem('isAuthenticatedUser')
		? JSON.parse(localStorage.getItem('isAuthenticatedUser')!)
		: false,
};

export const authenticatedUserSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		fetchUser(state, action: PayloadAction<UserData>) {
			state.user = action.payload;
		},
		setIsLogin(state, action: PayloadAction<boolean>) {
			state.isLogin = action.payload;
		},
		setIsFetching(state, action: PayloadAction<boolean>) {
			state.isFetching = action.payload;
		},
		setIsAuthenticatedUser(state, action: PayloadAction<boolean>) {
			state.isAuthenticatedUser = action.payload;
		},
	},
});

export const { fetchUser, setIsLogin, setIsFetching, setIsAuthenticatedUser } = authenticatedUserSlice.actions;

export default authenticatedUserSlice.reducer;
